import React from 'react';
import Types from './Types';
import Sizes from './Sizes';
import Disabled from './Disabled';
import Loading from './Loading';
import Icon from './Icon';

const ButtonComponent = () => {
  return (
    <div className="m-3">
      <h3>Buttons</h3>
      <p>Custom buttons with different types and sizes are available.</p>
      <Types />
      <Sizes />
      <Disabled />
      <Loading />
      <Icon />
    </div>
  );
};

export default ButtonComponent;
